/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_Nr as Nr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Yi as Yi,
} from "../../runtime/index.jsx";
export function AccionesEstadoTarea(e) {
  let t = (0, ReactCompiler.c)(11),
    { tarea: n, comprobantes: r, onMover: i, onPedirDia: a } = e;
  if (n.estado === `EN_REVISION`) {
    let e;
    return (
      t[0] === i
        ? (e = t[1])
        : ((e = (
            <AccionAsync
              onClick={() => i(`EN_PROGRESO`)}
              variante={`secundario`}
              icono={Yi}
              children={`No estaba lista — retomar`}
            />
          )),
          (t[0] = i),
          (t[1] = e)),
      e
    );
  }
  if (n.estado === `POR_HACER`) {
    let e;
    return (
      t[2] === i
        ? (e = t[3])
        : ((e = (
            <AccionAsync
              onClick={() => i(`EN_PROGRESO`)}
              textoOcupado={`Empezando…`}
              children={`Empezar`}
            />
          )),
          (t[2] = i),
          (t[3] = e)),
      e
    );
  }
  let o = r.length === 0,
    s;
  t[4] === a
    ? (s = t[5])
    : ((s = () => a(`EN_REVISION`)), (t[4] = a), (t[5] = s));
  let c = o
      ? `Agregá un comprobante (abajo) antes de darla por terminada`
      : void 0,
    l = o ? `Falta el comprobante` : `Marcar completada`,
    u;
  return (
    t[6] !== o || t[7] !== s || t[8] !== c || t[9] !== l
      ? ((u = (
          <AccionAsync
            disabled={o}
            onClick={s}
            icono={Nr}
            title={c}
            children={l}
          />
        )),
        (t[6] = o),
        (t[7] = s),
        (t[8] = c),
        (t[9] = l),
        (t[10] = u))
      : (u = t[10]),
    u
  );
}
